export const productConfig = {
  name: 'RegenLoop',
  tagline: 'Closed-loop outcomes intelligence for regenerative medicine',
  aiDisclaimer: 'Research and quality-support intelligence — not medical advice or a diagnostic device.',
  footerLegalLine: 'Outcomes-data & research-support platform. No medical or efficacy claims.',
} as const;
